import { render } from "./mosaic.svg?vue&type=template&id=17d84c4a"
const script = {}
script.render = render

export default script